var $ = global.jQuery = global.$;
var Form = require('./Form');
var Loading = require('./Loading');
var moment = require('moment');
var _find = require('lodash/collection/find');
var bookingLogic = require('../bookingLogic');

$.validator.addMethod('timeanddate', function(value, element, params) {
  // allow any non-whitespace characters as the host part
  return $('input[name=startTime]').val() !== '' && $('input[name=date]').val() !== '' ;
}, 'Please pick a time for your booking to start');


var states = {
  selected: {
    text: 'Selected',
    class: 'is-selected'
  },
  hovered: {
    bookText: 'Book it',
    declineText: 'Decline',
    class: 'is-hovered'
  },
  available: {
    text: 'Available',
    class: 'is-available'
  },
  semiAvailable: {
    text: 'Available',
    class: 'is-semi-available'
  },
  full: {
    text: 'Full',
    class: 'is-unavailable'
  }
};

function daysHtml(timeSlot, startMoment, endMoment, manHours, availability) {
  var html = '';
  for (var date = startMoment; date.valueOf() <= endMoment.valueOf(); date.add(1, 'days')) {
    if (date.day() === 0) continue;
    var available = bookingLogic.checkSlotAvailability(timeSlot, manHours, date.format('YYYY-MM-DD'), availability);
    var itemClass = states.available.class;
    var itemText = states.available.text;
    var buttonState = '';
    if (available === 0) {
      itemText = states.full.text;
      itemClass = states.full.class;
      buttonState = 'disabled';
    }
    if (available === 2) {
      itemText = states.semiAvailable.text;
      itemClass = states.semiAvailable.class;
      buttonState = 'disabled';
    }
    html += '<td><button data-settime class="booking-table__option ' + itemClass + '" data-date="' + date.format('YYYY-MM-DD') + '" data-time="' + timeSlot + '" ' + buttonState + '>' + itemText + '</button></td>';
  }
  return html;
}

function daysRow(startDate, endDate) {
  var startMoment = moment(startDate);
  var endMoment = moment(endDate);

  var html = '<thead><th></th>';

  for (var date = startMoment; date.valueOf() <= endMoment.valueOf(); date.add(1, 'days')) {
    if (date.day() === 0) continue;
    html += '<th>' + date.format('dddd Do') + '</th>';
  }
  html += '</thead>';

  return html;
}

/**
 * Track CSS properties
 * @class
 * @extends _Base
 */
var BookingTable = Form.extend(
  /** @lends StyleTrack.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    this.firstRun = true;
    this.loadingWidget = new Loading(this.$el);
    this.customValidation = {
      messages: {
        startTime: 'Please select a booking start time'
      }
    };
    this._super();
  },
  onWidgetsReady: function() {
    var self = this;
    this._super();
    this.availabilityUrl = this.$el.data('availabilityUrl');
    this.$tableArea = this.$el.find('[data-table-area]');
    this.$table = this.$el.find('[data-table]');
    this.$mobileTable = this.$el.find('[data-mobile-table]');
    this.$dates = this.$el.find('[data-dates]');
    this.$mobileDates = this.$el.find('[data-mobile-dates]');
    this.$weekTabs = this.$el.find('.tabs-nav__item');
    this.$daySelector = this.$el.find('[data-days]');
    this.$formSubmitBtn = this.$el.find('button[type="submit"]');

    // this.visibleStartDate = '2016-03-18';
    // this.visibleEndDate = '2016-03-23';
    this.currentManHours = Number(this.fields.ManHours.value);
    this.currentTeamId = Number(this.fields.TeamId.value);

    this.availability = {};

    this.$el.on('Field:Updated', function(event, name, value) {
      var numberValue = Number(value);
      self.isMobile = self.$mobileTable.is(':visible');
      if (name === 'ManHours' && value !== self.currentManHours) self.updateTable();
      if (name === 'TeamId' && value !== self.currentTeamId) self.getAvailability();
    });

    this.$el.on('submit', function() {
      self.loadingWidget.showMessage('Completing booking...');
    });

    this.setDate(moment());
    this.updateDays(moment());
    this.buildWeeks();
    this.getAvailability();

    $(window).on('resize orientationchange', function() {
      var isMobile = self.$mobileTable.is(':visible');

      if (self.isMobile !== isMobile) self.getAvailability();
    });
  },
  buildWeeks: function() {
    var self = this,
        tabs = [];

    for (var i=0;i<3;i++) {
      var periodStart = this.startMoment.clone().add(i*7, 'days');
      var periodEnd = periodStart.clone().add(6, 'days');
      var $tab = this.$weekTabs.eq(i);
      var startMonthName = periodStart.format('MMMM');
      var endMonthName = periodEnd.format('MMMM');
      var name = startMonthName + ' ' + periodStart.date() + ' - ' + ( endMonthName !== startMonthName ? endMonthName + ' ' : '' ) + periodEnd.date();
      tabs[i] = {
        name: name,
        startDate: periodStart.format('YYYY-MM-DD'),
        endDate: periodEnd.format('YYYY-MM-DD')
      };
      $tab
        .html('<a href="#">' + tabs[i].name + '</a>')
        .data('start', tabs[i].startDate)
        .data('end', tabs[i].endDate);
    }

    this.$weekTabs.eq(0).addClass('is-active');

    this.$weekTabs.on('click', function(event) {
      event.preventDefault();
      var $this = $(this);
      self.$weekTabs.removeClass('is-active');
      $this.addClass('is-active');
      self.setDate($this.data('start'));
      self.getAvailability();
    });

  },
  setDate: function(date) {
    var startMoment = moment(date);
    if (!this.startMoment) this.startMoment = moment();
    if (this.visibleStart && (startMoment.valueOf() > this.visibleStart.clone().add(6, 'days').valueOf() || startMoment.valueOf() < this.visibleStart.valueOf())) {
      this.updateDays(date);
    }
    $('[data-setdate]').removeClass('is-current');
    $('[data-setdate=' + startMoment.format('YYYY-MM-DD') + ']').addClass('is-current');
    $('[data-datemonth]').text(startMoment.format('MMM YYYY'));
    this.startMoment = startMoment;
  },
  updateDays: function(start) {
    var tpl = require('../templates/daySelector.dot');
    var days = [];
    var startMoment = moment(start);
    var endMoment = startMoment.clone().add(6, 'days');
    var self = this;

    this.visibleStart = startMoment;

    for (var date = startMoment.clone(); date.valueOf() <= endMoment.valueOf(); date.add(1, 'days')) {
      if (date.day() === 0) continue;
      days.push({
        dayName: date.format('ddd'),
        dayNo: date.date(),
        date: date.format('YYYY-MM-DD')
      });
    }

    var previous = startMoment.clone().subtract(7, 'days'),
        next = endMoment.clone().add(1, 'days');

    var html = tpl({
      month: startMoment.format('MMMM YYYY'),
      days: days,
      previous: previous.format('YYYY-MM-DD'),
      previousDisabled: previous.valueOf() < moment().valueOf() && !previous.isSame(moment(), 'day'),
      next: next.format('YYYY-MM-DD'),
      nextDisabled: next.valueOf() > moment().add(20, 'days') && !next.isSame(moment().add(20, 'days'), 'day')
    });

    var $html = $(html);

    $html.find('[data-setdate]').on('click', function(event) {
      event.preventDefault();
      self.setDate($(this).data('setdate'));
      self.getAvailability();
    });

    this.$daySelector.html($html);

    $('[data-setdate=' + startMoment.format('YYYY-MM-DD') + ']').addClass('is-current');
    $('[data-datemonth]').text(startMoment.format('MMM YYYY'));
  },
  getAvailability: function() {
    var self = this;
    var startMoment = this.startMoment.clone();
    this.isMobile = this.$mobileTable.is(':visible');
    this.visibleStartDate = startMoment.format('YYYY-MM-DD');
    this.visibleEndDate = this.isMobile ? startMoment.format('YYYY-MM-DD') : startMoment.add(6, 'days').format('YYYY-MM-DD');
    var bookingCall = bookingLogic.getAvailability(this.visibleStartDate, this.visibleEndDate, this.fields.TeamId.value, this.availabilityUrl);

    bookingCall.done(function(response) {
      if (response.Value || response[0]) {
        self.currentTeamId = self.fields.TeamId.value;
        self.currentAvailability = bookingLogic.availability[self.currentTeamId];
        self.updateTable();
        if (self.firstRun) {
          setTimeout(function() {
            self.$el.trigger('Loading:Success');
          },500);
        }
      } else if (response.Error && response.Error !== '') {
        self.$el.trigger('Loading:Failed',[response.Error]);
      }
    });
    bookingCall.fail(function() {
      self.$el.trigger('Loading:Failed');
    });
    bookingCall.always(function() {
      self.firstRun = false;
    });
  },
  updateTable: function() {
    var self = this,
        manHours = Number(this.fields.ManHours.value);

    if (manHours === 0) {
      this.$tableArea.velocity('slideUp');
    } else {
      if (!this.$tableArea.is(':visible')) this.$tableArea.velocity('slideDown');
    }

    var $table = this.isMobile ? this.$mobileTable : this.$table;

    $table.html(this.buildTable(this.visibleStartDate, this.visibleEndDate, manHours, this.currentAvailability, true));

    $table.find('[data-settime]').not('[disabled]').on('click', function(event) {
      event.preventDefault();
      var selectedOption = {
        StartTime: $(this).data('time'),
        Date: $(this).data('date')
      };
      if ($(this).hasClass(states.selected.class)) {
        self.unsetSelectedOption(selectedOption);
      } else {
        self.setSelectedOption(selectedOption);
      }
      
    });

    $table.find('[data-settime]').not('[disabled]').on('mouseover', function(event) {
      $(this).data('text', $(this).text());
      $(this).addClass(states.hovered.class);
      if ($(this).hasClass(states.selected.class)) {
        $(this).text(states.hovered.declineText);
      } else {
        $(this).text(states.hovered.bookText);
      }
    });
    $table.find('[data-settime]').not('[disabled]').on('mouseout', function(event) {
      $(this)
        .removeClass(states.hovered.class)
        .text($(this).data('text'));
    });

    this.setFieldValues({
      StartTime: '',
      Date: ''
    });
  },
  setSelectedOption: function(selectedOption) {
    var self = this;
    var startTime = Number(selectedOption.StartTime);
    $('[data-date].' + states.selected.class)
      .text(states.available.text)
      .removeClass(states.selected.class);
    for (var i=startTime;i<startTime + this.currentManHours;i++) {
      $('[data-date=' + selectedOption.Date + '][data-time=' + i + ']')
        .text(states.selected.text)
        .data('text', states.selected.text)
        .addClass(states.selected.class);
    }
    this.setFieldValues(selectedOption);
    self.enableSubmitButton();
  },
  unsetSelectedOption: function(selectedOption) {
    var self = this;
    var startTime = Number(selectedOption.StartTime);
    $('[data-date].' + states.selected.class)
      .text(states.available.text)
      .data('text', states.available.text)
      .removeClass(states.selected.class);
    self.disableSubmitButton();
  },
  buildTable: function(startDate, endDate, manHours, availability, showDays) {
    var self = this;
    this.currentManHours = manHours;
    var startMoment;
    var endMoment = moment(endDate);
    var html = '<table class="booking-table">';
    if (showDays) html += daysRow(startDate, endDate);
    for (var i = bookingLogic.DAYSTART;i<bookingLogic.DAYEND;i++) {
      html += '<tr data-time="' + i + '">' + '<th>' + i + ':00 - ' + (i + 1) + ':00</th>';
      startMoment = moment(startDate);
      html += daysHtml(i, startMoment, endMoment, manHours, availability);
      html += '</tr>';
    }
    html += '</table>';

    self.disableSubmitButton();
    return html;
  },
  disableSubmitButton: function() {
    this.$formSubmitBtn.attr('disabled', true);
  },
  enableSubmitButton: function() {
    this.$formSubmitBtn.attr('disabled', false);
  }
});

module.exports = BookingTable;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/BookingTable.js
// module id = 125
// module chunks = 0